import React from "react";
import { format, parse, isValid } from 'date-fns';
import { es } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import styles from "./styles";
import { connect } from "react-redux";
import MaskedInput from "react-text-mask";
import * as actionsPresentacion from "../../../../actions/nuevaPresentacion";
import * as actionsVentanaDialogo from "../../../../actions/ventanaDialogo";
import { Container, Typography, MenuItem, Tooltip, InputAdornment, IconButton } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { TextFieldCustom, TextFieldDate } from "../../../common/UI/Personalizaciones/TextField";
import BtnAdjuntar from "../../../Presentacion/Adjuntos/BtnAdjuntarArchivos";
import ListadoArchivos from "../../../Presentacion/Adjuntos/ListadoArchivos";
import clearInputIcon from '../../../../assets/iconos/clear-input-icon.png';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

const Comprobantes = (props) => {
    const classes = styles();

    const actualizarTipoPrestacion = (valor) => {
        props.seleccionarTipoPrestacion(valor);
        if(props.tipoComprobantesSeleccionado === '' && props.codigoComprobanteSeleccioado === ''){
            props.actualizarRequeridos("tipoComprobante", false);
            props.actualizarRequeridos("codComprobante", false);
            props.actualizarRequeridos("nroComprobante", false);
            props.actualizarRequeridos("facturas", false);
            props.actualizarRequeridosEsValido("tipoComprobante", false);
            props.actualizarRequeridosEsValido("codComprobante", false);
            props.actualizarRequeridosEsValido("nroComprobante", false);
            props.actualizarRequeridosEsValido("tipoPrestacion", false);
        }
    };

    const actualizarTipoComprobante = (valor) => {
        const comprobante = {
            id: valor,
            codigos: [],
        };
        const codigo = {
            id: '',
            letra: '',
        }
        props.seleccionarTipoComprobante(comprobante);
        props.seleccionarCodigoComprobante(codigo);
        if(props.tipoPrestacionSeleccionada === '') {
            props.actualizarRequeridos("tipoComprobante", false);
            props.actualizarRequeridos("codComprobante", false);
            props.actualizarRequeridos("nroComprobante", false);
            props.actualizarRequeridos("facturas", false);
            props.actualizarRequeridosEsValido("tipoComprobante", false);
            props.actualizarRequeridosEsValido("tipoComprobante", false);
            props.actualizarRequeridosEsValido("codComprobante", false);
            props.actualizarRequeridosEsValido("nroComprobante", false);
        }
    };

    const actualizarCodigoComprobante = (valor) => {
        const codigo = {
            id: '',
            letra: '',
        }
        props.seleccionarCodigoComprobante(codigo);
        if(props.tipoPrestacionSeleccionada === '' && props.tipoComprobantesSeleccionado === '') {
            props.actualizarRequeridos("tipoComprobante", false);
            props.actualizarRequeridos("codComprobante", false);
            props.actualizarRequeridos("nroComprobante", false);
            props.actualizarRequeridos("facturas", false);
            props.actualizarRequeridosEsValido("tipoComprobante", false);
            props.actualizarRequeridosEsValido("tipoComprobante", false);
            props.actualizarRequeridosEsValido("codComprobante", false);
            props.actualizarRequeridosEsValido("nroComprobante", false);
        }

    }

    const tipoFacturaHandleChange = async (id) => {
        const tipoComprobanteId = id;            
        const comprobante = props.tipoComprobantes.filter(
            (elemento) => elemento.id === tipoComprobanteId
        )[0];
        
        props.seleccionarTipoComprobante(comprobante);
        props.actualizarRequeridosEsValido("tipoComprobante", true);

        if (props.tipoPresentacionSeleccionada === 3){
            props.actualizarRequeridos("tipoComprobante", true);
            props.actualizarRequeridos("codComprobante", true);
            props.actualizarRequeridos("nroComprobante", true);
            props.actualizarRequeridos("facturas", true);
        }

        if (tipoComprobanteId !== 1){
            props.actualizarRequeridos("prestaciones", false);
            props.actualizarRequeridos("liquidaciones", false);
            props.actualizarRequeridos("internaciones", false)
        }else{
            props.actualizarRequeridos("prestaciones",  true);
            props.actualizarRequeridos("liquidaciones", props.tipoPresentacionSeleccionada === 3 ? false :true); 
            props.actualizarNroReferencia('');
            if (props.tipoPrestacionSeleccionada === 2)
                props.actualizarRequeridos("internaciones", props.tipoPresentacionSeleccionada === 3 ? false : true);  
        
        }
    
    };

    const codigoComprobanteHandlerChange = (id) => {
        const idCodigoComprobante = id;

        const codigo = props.codigosComprobante.filter(
            (elemento) => elemento.id === idCodigoComprobante
        )[0];
        props.seleccionarCodigoComprobante(codigo);

        props.actualizarRequeridosEsValido("codComprobante", true);
        if (props.tipoComprobantesSeleccionado === 1 && (codigo.id === 3 || codigo.id === 4)){
            props.actualizarRequeridos('fechaEmisionComp', true);
        } else {
            props.actualizarRequeridos('fechaEmisionComp', false);
        }
    };

    const TextMaskCustom = (props) => {
        const { inputRef, letra, ...other } = props;
        const placeholder =
            letra && letra !== ""
                ? letra + "-####-########"
                : "A-####-########";

        const minuscula = letra && letra !== "" ? letra.toLowerCase() : "";
        const mask = [
            new RegExp("[" + letra + minuscula + "]"),
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
        ];
        return (
            <MaskedInput
                {...other}
                ref={(ref) => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={mask}
                placeholder={placeholder}
                guide={false}
                id="nroFactura"
            />
        );
    };

    const tipoPrestacionHandler = (tipoPrestacionId) => {
        props.seleccionarTipoPrestacion(tipoPrestacionId);
        props.actualizarRequeridosEsValido("tipoPrestacion", true);

        if (props.tipoPresentacionSeleccionada === 3){
            props.actualizarRequeridos("tipoComprobante", true);
            props.actualizarRequeridos("codComprobante", true);
            props.actualizarRequeridos("nroComprobante", true);
            props.actualizarRequeridos("facturas", true);
        }
       
        if (tipoPrestacionId === 2 && (!props.tipoComprobantesSeleccionado || 
            props.tipoComprobantesSeleccionado === 1)) {
            props.actualizarRequeridos("internaciones", props.tipoPresentacionSeleccionada === 3 ? false : true);
        } else {
            props.actualizarRequeridos("internaciones", false);
        }
    };

    const nroComprobanteHandlerChange = (nroComprobante,codPrestador,codComprobante) => {
        const regExp = new RegExp(
            "[" +
                props.letraComprobante +
                props.letraComprobante.toLowerCase() +
                "]-\\d{4,4}-\\d{8,8}"
        );

        const valido = regExp.test(nroComprobante);

        props.actualizarNroFactura(nroComprobante);
        props.actualizarRequeridosEsValido("nroComprobante", valido);

        const mensaje = "El nº de comprobante inválido";
        props.actualizarMensajesError(
            "nroComprobante",
            !valido ? mensaje : null
        );

        if(valido){
            props.validaNroCompPresDisp(nroComprobante,codPrestador,codComprobante);
        }
    };

    const fechaEmisionCompHandleChange = (value) => {
        if (value && !value.includes('_')) {
            const fecha = parse(value, 'dd/MM/yyyy', new Date());
            const valido = isValid(fecha);
            
            if (valido) {
                const fechaFormateadaEstado = format(fecha, 'yyyy-MM-dd HH:mm:ss');
                props.actualizarFechaEmisionComp(fechaFormateadaEstado);
                handleFechaEmisionCompValidation(value);
            }
        } else if (value === null || value.length === 0) {
            props.actualizarFechaEmisionComp(null);
            props.actualizarRequeridosEsValido("fechaEmisionComp", false);
        }
        
    };
    
    const cerrarDialogo = () => {
        const ventanaConfig = {
            estaVisible: false,
        };
        
        props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    const handleFechaEmisionCompValidation = (value) => {
        let mensaje = `Fecha debe ser menor o igual a ${format(new Date(), 'dd/MM/yyyy')}`;
        let valido = true;
        if (!value || value.includes('_')){
            valido = false;
        } else {
            const fecha = parse(value, 'dd/MM/yyyy', new Date());
            if (isValid(fecha)) {
                const fechaActual = new Date(new Date().toLocaleDateString());
                const diff = Math.ceil((fechaActual.getTime() - fecha.getTime()) / (1000 * 3600 * 24));
                valido = fecha < new Date();
                props.actualizarRequeridosEsValido("fechaEmisionComp", true);
                if (diff > 3) {
                    const ventanaConfig = {
                        estaVisible: true,
                        titulo: "Por normativas de la AFIP:",
                        mensaje: `Independientemente de la puesta a disposición del comprobante electrónico que efectúe AFIP a través del Domicilio Fiscal Electrónico, el emisor de dicho documento deberá ponerlo a disposición del respectivo receptor hasta la hora 24 del día inmediato siguiente al de su emisión, con toda la información que cada comprobante debe contener conforme lo establecido en el apartado A del Anexo II de la Resolución General N° 1.415 y el artículo 5° de la Ley N° 27.440, según corresponda.\n\nSi la factura no se llega a liquidar será rechazada.`,
                        esAlerta: true,
                        clickAceptar: cerrarDialogo,
                        textoBtnAceptar: "Aceptar",
                    };
                    props.actualizarAtriutoVentanaDialogo(ventanaConfig);
                }
            } else {
                valido = false;
            }
        }
        props.actualizarMensajesError(
            "fechaEmisionComp",
            !valido ? mensaje : null
        );
        props.actualizarRequeridosEsValido("fechaEmisionComp", valido);
    }
        
    const nroReferenciaHandlerChange = (nroReferencia) => {
        props.actualizarNroReferencia(nroReferencia);
    }

    const long = props.facturaFile.length;
    const hasProperty = props.facturaFile.filter(f => f.hasOwnProperty("bajaLogica")).length;

    const habilitacionInput =   props.estaVinculada || long - hasProperty > 1;


    if (
        !props.prestadorSeleccionado ||
        props.tipoPresentacionSeleccionada === 2 ||
        props.tipoPresentacionSeleccionada === "" 
    ) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <Container
                disableGutters={true}
                className={classes.containerTitulo}
            >
                <Typography className={classes.tituloSeccion}>
                    Datos de comprobantes {" "}
                    {props.requeridos.liquidaciones.requerido ? "*" : ""}
                </Typography>
                <Tooltip
                    placement="right"
                    title={
                        <>
                            <strong>DETALLE DEL COMPROBANTE</strong>
                            <br />
                            Extensiones permitidas: "PDF"
                            <br />
                            Extensiones opcionales: "JPG", "JPEG", y "PNG"
                            <br />
                            Requerido
                        </>
                    }
                >
                    <Typography className={classes.ayuda}>?</Typography>
                </Tooltip>
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                <TextFieldCustom
                    className={classes.tipoPrestacion}
                    select={!props.soloVista}
                    variant="outlined"
                    label="Tipo de Prestación"
                    size="small"
                    required={props.requeridos.tipoComprobante.requerido}
                    value={
                        props.soloVista
                            ? props.tipoPrestacionDescripcion
                            : props.tipoPrestacionSeleccionada
                    }
                    disabled={props.esEdicion && props.estaVinculada}
                    inputProps={{ readOnly: props.soloVista }}
                    InputProps={
                        !props.soloVista && props.tipoPrestacionSeleccionada !== '' && props.tipoPresentacionSeleccionada === 3 ?
                                {
                                    endAdornment: (
                                        <InputAdornment position='start'>
                                            <IconButton
                                                className={
                                                    classes.iconoClearEstado
                                                }
                                                size='small'
                                                onClick={() =>
                                                    actualizarTipoPrestacion(
                                                        ''
                                                    )
                                                }
                                            >
                                                <img
                                                    src={clearInputIcon}
                                                    alt='Vaciar contenido'
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                             : null       
                            }
                    SelectProps={{
                        IconComponent: (props) => (
                            <KeyboardArrowDownIcon
                                fontSize="small"
                                className={`${classes.dropDownIcon}, ${props.className}`}
                            />
                        ),
                    }}
                    onChange={(event) =>
                        tipoPrestacionHandler(event.target.value)
                    }
                    onBlur={() =>
                        props.actualizarMensajesError(
                            "tipoPrestacion",
                            !props.tipoPrestacionSeleccionada
                                ? "Debe seleccionar una opción"
                                : null
                        )
                    }
                    error={!!props.errorMensaje.tipoPrestacion}
                    helperText={
                        props.errorMensaje.tipoPrestacion &&
                        props.errorMensaje.tipoPrestacion
                    }
                >
                    {props.tipoPrestaciones.map((elemento) => (
                        <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.descripcion}
                        </MenuItem>
                    ))}
                </TextFieldCustom>
                <TextFieldCustom
                    className={classes.tipoComprobante}
                    select={!props.soloVista}
                    variant="outlined"
                    label="Tipo de comprobante"
                    size="small"
                    required={props.requeridos.facturas.requerido}
                    value={
                        props.soloVista
                            ? props.tipoComprobanteDescripcion ?? ""
                            : props.tipoComprobantesSeleccionado
                    }
                    disabled={props.esEdicion && props.estaVinculada}
                    inputProps={{ readOnly: props.soloVista }}
                    InputProps={
                        !props.soloVista && props.tipoComprobantesSeleccionado !== '' && props.tipoPresentacionSeleccionada === 3 ?
                                {
                                    endAdornment: (
                                        <InputAdornment position='start'>
                                            <IconButton
                                                className={
                                                    classes.iconoClearEstado
                                                }
                                                size='small'
                                                onClick={() =>
                                                    actualizarTipoComprobante(
                                                        ''
                                                    )
                                                }
                                            >
                                                <img
                                                    src={clearInputIcon}
                                                    alt='Vaciar contenido'
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                             : null       
                            }
                    SelectProps={{
                        IconComponent: (props) => (
                            <KeyboardArrowDownIcon
                                fontSize="small"
                                className={`${classes.dropDownIcon}, ${props.className}`}
                            />
                        ),
                    }}
                    onChange={(event) =>
                        tipoFacturaHandleChange(event.target.value)
                    }
                    onBlur={() =>
                        props.actualizarMensajesError(
                            "tipoComprobante",
                            !props.tipoComprobantesSeleccionado
                                ? "Debe seleccionar una opción"
                                : null
                        )
                    }
                    error={!!props.errorMensaje.tipoComprobante}
                    helperText={
                        props.errorMensaje.tipoComprobante &&
                        props.errorMensaje.tipoComprobante
                    }
                >
                    {props.tipoComprobantes.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.descripcion}
                        </MenuItem>
                    ))}
                </TextFieldCustom>
                <TextFieldCustom
                    className={classes.codComprobante}
                    select={!props.soloVista}
                    variant="outlined"
                    label="Código de comprobante"
                    size="small"
                    required={props.requeridos.codComprobante.requerido}
                    value={
                        props.soloVista
                            ? props.codigoComprobanteDescripcion  ?? ""
                            : props.codigoComprobanteSeleccioado 
                    }
                    disabled={props.esEdicion && props.estaVinculada}
                    inputProps={{ readOnly: props.soloVista }}
                    InputProps={
                        !props.soloVista && props.codigoComprobanteSeleccioado !== '' && props.tipoPresentacionSeleccionada === 3 ?
                                {
                                    endAdornment: (
                                        <InputAdornment position='start'>
                                            <IconButton
                                                className={
                                                    classes.iconoClearEstado
                                                }
                                                size='small'
                                                onClick={() =>
                                                    actualizarCodigoComprobante(
                                                        ''
                                                    )
                                                }
                                            >
                                                <img
                                                    src={clearInputIcon}
                                                    alt='Vaciar contenido'
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                             : null       
                            }
                    SelectProps={{
                        IconComponent: (props) => (
                            <KeyboardArrowDownIcon
                                fontSize="small"
                                className={`${classes.dropDownIcon}, ${props.className}`}
                            />
                        ),
                    }}
                    onChange={(event) =>
                        codigoComprobanteHandlerChange(event.target.value)
                    }
                    onBlur={() =>
                        props.actualizarMensajesError(
                            "codComprobante",
                            !props.codigoComprobanteSeleccioado
                                ? "Debe seleccionar una opción"
                                : null
                        )
                    }
                    error={!!props.errorMensaje.codComprobante}
                    helperText={
                        props.errorMensaje.codComprobante &&
                        props.errorMensaje.codComprobante
                    }
                >
                    {props.codigosComprobante.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.codigo} - {option.descCodigo}
                        </MenuItem>
                    ))}
                </TextFieldCustom>
                <TextFieldCustom
                    id="nroComprobante"
                    label="Nº de comprobante"
                    className={`${classes.nroComprobante} ${
                        props.nroFactura && !props.soloVista
                            ? classes.outlinedInput
                            : ""
                    }`}
                    size="small"
                    variant="outlined"
                    required={props.requeridos.nroComprobante.requerido}
                    disabled={props.esEdicion && props.estaVinculada}
                    InputProps={{
                        inputComponent: TextMaskCustom,
                        inputProps: {
                            letra: props.letraComprobante,
                            readOnly: props.soloVista,
                        },
                        value: props.nroFactura.toUpperCase(),
                        onBlur: (event) =>
                            nroComprobanteHandlerChange(event.target.value,props.prestadorSeleccionado.codPrestador,props.codigoComprobanteSeleccioado),
                    }}
                    error={!!props.errorMensaje.nroComprobante}
                    helperText={
                        props.errorMensaje.nroComprobante &&
                        props.errorMensaje.nroComprobante
                    }
                />
                {
                    (props.tipoComprobantesSeleccionado === 1 && (props.codigoComprobanteSeleccioado === 3 || props.codigoComprobanteSeleccioado === 4)) && (
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                            <TextFieldDate
                                disableToolbar
                                clearable
                                format='dd/MM/yyyy'
                                label='Emisión comprobante'
                                size='small'
                                inputVariant='outlined'
                                className={classes.fechaEmision}
                                value={props.fechaEmisionComp}
                                disabled={props.esEdicion && props.estaVinculada}
                                required={true}
                                readOnly={props.soloVista}
                                error={!!props.errorMensaje.fechaEmisionComp}
                                helperText={
                                    props.errorMensaje.fechaEmisionComp &&
                                    props.errorMensaje.fechaEmisionComp
                                }
                                onChange={(event, date) => {fechaEmisionCompHandleChange(date)}}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                okLabel='Ok'
                                clearLabel='Borrar'
                                cancelLabel='Cancelar'
                            />
                        </MuiPickersUtilsProvider>
                    )
                }
                {(!props.tipoComprobantesSeleccionado || props.tipoComprobantesSeleccionado !== 1 &&
                <TextFieldCustom
                    id="nroReferencia"
                    name="nroReferencia"
                    label="Nº de referencia"
                    variant="outlined"
                    size="small"
                    type="text"
                    className={classes.nroReferencia}
                    value={props.nroReferencia}
                    disabled={props.esEdicion && props.estaVinculada}
                    inputProps={{ readOnly: props.soloVista,
                                  maxLength: 20,
                                }}
                    onChange={(event) =>
                        nroReferenciaHandlerChange(event.target.value)
                    }
                />)}
            </Container>
            {( props.tipoPrestacionSeleccionada === ''  && props.tipoComprobantesSeleccionado === '' 
                && props.codigoComprobanteSeleccioado === '' && props.tipoPresentacionSeleccionada === 3 ? 
                null :         
                <Container disableGutters={true} className={classes.filaInputs}>
                    <BtnAdjuntar
                            extensionesAceptadas=".jpg,.jpeg,.png,.pdf"
                            multiplesArchivos={false}
                            path={props.pathTemporal}
                            seccion="facturas"
                            archivosHandler={props.actualizarFacturaFile}
                            archivosSubidos={props.facturaFile}
                            deshabilitado={habilitacionInput || props.soloVista}
                    />
                    <ListadoArchivos
                        seccion="facturas"
                        archivosHandler={props.actualizarFacturaFile}
                        archivosSubidos={props.facturaFile}
                        deshabilitado={props.estaVinculada || props.soloVista}
                    />
                </Container>)}
        </Container>
    );
};

const mapStateToProps = (state) => {

    const tipoPrestacion = state.nuevaPresentacionReducer.tipoPrestaciones.find(
        (t) =>
            t.id === state.nuevaPresentacionReducer.tipoPrestacionSeleccionada
    );
    const tipoComprobante = state.nuevaPresentacionReducer.tipoComprobantes.find(
        (t) =>
            t.id === state.nuevaPresentacionReducer.tipoComprobantesSeleccionado
    );
    const codigoComprobante = state.nuevaPresentacionReducer.codigosComprobante.find(
        (t) =>
            t.id === state.nuevaPresentacionReducer.codigoComprobanteSeleccioado
    );
    
   
    return {
        pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
        prestadorSeleccionado:
            state.nuevaPresentacionReducer.prestadorSeleccionado,
        tipoPresentacionSeleccionada:
            state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
        tipoComprobantes: state.nuevaPresentacionReducer.tipoComprobantes,
        tipoComprobantesSeleccionado:
            state.nuevaPresentacionReducer.tipoComprobantesSeleccionado,
        codigosComprobante: state.nuevaPresentacionReducer.codigosComprobante,
        letraComprobante: state.nuevaPresentacionReducer.letraComprobante,
        tipoPrestacionSeleccionada:
            state.nuevaPresentacionReducer.tipoPrestacionSeleccionada,
        facturaFile: state.nuevaPresentacionReducer.facturaFile,
        nroFactura: state.nuevaPresentacionReducer.nroFactura,
        fechaEmisionComp: state.nuevaPresentacionReducer.fechaEmisionComp,
        nroReferencia: state.nuevaPresentacionReducer.nroReferencia,
        estaVinculada: state.nuevaPresentacionReducer.estaVinculada,
        soloVista: state.nuevaPresentacionReducer.soloVista,
        requeridos: state.nuevaPresentacionReducer.requeridos,
        esEdicion: state.nuevaPresentacionReducer.esEdicion,
        tipoPrestaciones: state.nuevaPresentacionReducer.tipoPrestaciones,
        codigoComprobanteSeleccioado:
            state.nuevaPresentacionReducer.codigoComprobanteSeleccioado,
        errorMensaje: state.nuevaPresentacionReducer.errorMensaje,
        tipoPrestacionDescripcion: tipoPrestacion
            ? tipoPrestacion.descripcion
            : "",
        tipoComprobanteDescripcion: tipoComprobante
            ? tipoComprobante.descripcion
            : "",
        codigoComprobanteDescripcion: codigoComprobante
            ? codigoComprobante.codigo + ' - ' + codigoComprobante.descCodigo
            : "",
    };
};

const actionCreators = {
    seleccionarTipoComprobante: actionsPresentacion.seleccionarTipoComprobante,
    actualizarFacturaFile: actionsPresentacion.actualizarFacturaFile,
    actualizarNroFactura: actionsPresentacion.actualizarNroFactura,
    actualizarFechaEmisionComp: actionsPresentacion.actualizarFechaEmisionComp,
    actualizarAtriutoVentanaDialogo: actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    actualizarNroReferencia: actionsPresentacion.actualizarNroReferencia,
    seleccionarCodigoComprobante:
        actionsPresentacion.seleccionarCodigoComprobante,
    seleccionarTipoPrestacion: actionsPresentacion.seleccionarTipoPrestacion,
    buscarTiposPrestaciones: actionsPresentacion.buscarTiposPrestacionesPresentacion,
    actualizarRequeridosEsValido:
        actionsPresentacion.actualizarRequeridosEsValido,
    actualizarRequeridos: actionsPresentacion.actualizarRequeridos,
    actualizarMensajesError: actionsPresentacion.actualizarMensajesError,
    validaNroCompPresDisp: actionsPresentacion.validaNroCompPresDisp
};

export default connect(mapStateToProps, actionCreators)(Comprobantes);
